import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteFilterEntry = contentfulGql`#graphql
  fragment EntWebsiteFilterEntry on EntWebsiteFilterEntry {
    label
    value
  }
`;

export const entWebsiteFilters = contentfulGql`#graphql
  ${entWebsiteFilterEntry}
  fragment EntWebsiteFilters on EntWebsiteFilters {
    name
    filtersCollection {
      items {
        ...EntWebsiteFilterEntry
      }
    }
  }
`;

export const entResourceHubCollectionWithSearch = contentfulGql`#graphql
  ${entWebsiteFilters}
  fragment EntWebsiteResourceHubCollectionWithSearch on EntWebsiteResourceHubCollectionWithSearch {
    slug
    enableSearch
    useCaseFilters {
      ...EntWebsiteFilters
    }
    contentTypes
    domains
    listOfCardSlugsToExcludeFromSearch
  }
`;

export const entWebsiteBlockResourceHubCollectionWithSearchQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entResourceHubCollectionWithSearch}

  query entWebsiteBlockResourceHubCollectionWithSearch($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteResourceHubCollectionWithSearch
      }
    }
  }
`;
